export const icon = '';

export const iconSelect = (ext) => {
  if (ext.match(/\.(aif|cda|mid|mp3|mpa|ogg|wav|wma|wpl)/i)) {
    return 'music_note';
  } else if (ext.match(/\.(7z|arj|deb|pkg|rar|rpm|tar\.gz|z|zip)/i)) {
    return 'layers';
  } else if (ext.match(/\.(dmg|iso|toast|vcd)/i)) {
    return 'album';
  } else if (ext.match(/\.(csv|dat|dbf?|log|mdb|sav|sql|tar|xml)/i)) {
    return 'dns';
  } else if (ext.match(/\.(apk|bin|bat|cgi|pl|com|exe|gadget|jar|wsf)/i)) {
    return 'build';
  } else if (ext.match(/\.(fnt|fon|otf|ttf)/i)) {
    return 'text_fields';
  } else if (ext.match(/\.(ai|bmp|gif|ico|jpe?g|png|ps|psd|svg|tiff?)/i)) {
    return 'photo';
  } else if (ext.match(/\.(asp|cer|cfm|cgi|css|html?|jsp|part|rss|xhtml)/i)) {
    return 'language';
  } else if (ext.match(/\.(key|odp|pps|pptx?)/i)) {
    return 'slideshow';
  } else if (ext.match(/\.(c|class|cpp|cs|h|java|sh|jsx?|py|swift|vb|php)/i)) {
    return 'code';
  } else if (ext.match(/\.(ads|xlr|xlsx?)/i)) {
    return 'poll';
  } else if (ext.match(/\.(bak|cab|cfg|cpl|cur|dll|dmp|drv|icns|ico|ini|lnk|msi|sys|tmp)/i)) {
    return 'settings';
  } else if (ext.match(/\.(3g2|3gp|avi|flv|h264|m4v|mkv|mov|mp4|mpe?g|rm|swf|vob|wmv)/i)) {
    return 'movie_creation';
  } else if (ext.match(/\.(docx?|odt|pdf|rtf|tex|txt|wks|wdp)/i)) {
    return 'description';
  }
  return 'insert_drive_file';
};



// WEBPACK FOOTER //
// ./src/utils/iconSelect.js